query MigrationsListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: MigrationsFilterInput
) {
  migrations(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      title
      status
      error
      attemptsMade
      lastRunAt
      createdAt
    }
  }
}
